import React, {useState, useEffect} from 'react'
import {useHistory} from 'react-router'
import {connect, useSelector} from 'react-redux'
import {logEvent} from '../../Utils/utils'

/* imgs */
import IcAgreement from '../../assets/img/ic_yapp_approved.svg'
import CustomSelect from '../../Components/Forms/CustomSelect'
import productImg from '../../assets/img/prescription.png'
import CardProduct from '../../Components/CardProduct/CardProduct'
import {getProfessionalDiscountCode} from '../../Utils/api'
import Iframe from 'react-iframe'
import {getJWTdata} from '../../Utils/tools'
import loadingYapp from '../../assets/img/yapp_loading.gif'

const _ = require('lodash')

function NewAgreement(props) {
  const history = useHistory()

  const [optionsData, setOptionsData] = useState([])
  const [filteredProducts, setFilteredProducts] = useState([])
  const [products, setProducts] = useState([])
  const typeFormUrl = useSelector((state) => state?.app?.config?.typeform_url)
  const [loading, setLoading] = useState(true)
  const identity = useSelector((state) => state.user.identity)

  useEffect(async () => {
    try {
      let additionalMenu = []
      let products = []
      let categories = []
      try {
        let jwtData = getJWTdata()
        additionalMenu = await getProfessionalDiscountCode(
          jwtData?.user_id,
          identity,
        )
      } catch (ignore) {}

      if (additionalMenu.data[0]?.length > 0) {
        categories = additionalMenu.data[2]
        products = _.orderBy(
          additionalMenu.data[1],
          (product) => product.product_name,
          ['asc'],
        )
        setProducts(products)
        let newCategories = _.filter(categories, (category) =>
          _.find(products, {category_id: category.id}),
        )
        let category = newCategories.map((item) => {
          return {
            label: item?.category_name,
            value: item?.id,
          }
        })
        setOptionsData([...[{label: 'todas', value: null}], ...category])
        setFilteredProducts([...products])
      } else {
      }
    } catch (ignore) {
    } finally {
      setLoading(false)
    }
  }, [])

  function goBack() {
    history.goBack()
  }

  function goTo(product) {
    logEvent('Medication Sheet Checked', {
      Origin: 'Yapp Benefit',
      'Product Id': product.product_id,
      'Product Name': product?.product_name,
      'Lab Name': product?.laboratory_name,
      'Category Id': product?.category_id,
    })
    history.push(`/product/detail/${product.product_id}`, {
      product_id: product.product_id,
      product: product,
      isComesFromMedicationSheet: true,
    })
  }

  function applyFilter(value) {
    if (value?.value === null) return setFilteredProducts(products)
    let newFilteredProducts = _.filter(products, {category_id: value?.value})
    setFilteredProducts([...newFilteredProducts])
  }

  return (
    <div className="flex-grow-1 px-3">
      {loading ? (
        <div className="d-flex justify-content-center w-100 py-5">
          <img src={loadingYapp} alt="loading" height={100} />
        </div>
      ) : products?.length > 0 ? (
        <>
          <div className="content-responsive mx-auto pt-3">
            {/* <div className="mb-3">
              <BannerConvenioPro />
            </div> */}
            <div className="content-card-light mb-3">
              <div className="d-flex align-items-center mb-3">
                <img src={IcAgreement} alt="Agreement" />
                <h3 className="txt-2--regular-db m-0 ml-3">
                  Ayuda a tus pacientes con tu código de médico
                </h3>
              </div>
              <div>
                <p className="txt-5--regular-db m-0 mb-3">
                  Este nuevo convenio te permitirá apoyar a tus pacientes a
                  través descuentos en sus tratamientos.
                </p>
                <p className="txt-5--regular-db m-0 mb-3">
                  Busca un medicamento adherido y podrás compartir tu código
                  desde la tarjeta del convenio yapp. Ingresa el correo de tu
                  paciente y le enviaremos tu código para que pueda acceder a
                  los descuentos asociados a su tratamiento canjeables desde la
                  web y/o app. Así podrá recibir en su hogar sus medicamentos
                  crónicos todos los meses al mejor precio posible.
                </p>
                <p className="txt-5--bold-db m-0 mb-2">
                  Instrucciones para tus pacientes: Descargar la app de Yapp{' '}
                  {`\>`} Crear una cuenta {`\>`} Agregar el medicamento al carro{' '}
                  {`\>`} Ingresar el código entregado por ti en el checkout de
                  compra.
                </p>
              </div>
            </div>
            <div className="content-card-light">
              <div className="m-0 mb-3">
                <h3 className="txt-4--bold-db m-0">
                  Listado de medicamentos adheridos
                </h3>
              </div>
              <div>
                <div className="w-100 mb-3">
                  <CustomSelect options={optionsData} onChange={applyFilter} />
                </div>
                <div className="content-card-product">
                  {filteredProducts.map((item, key) => (
                    <CardProduct
                      key={key}
                      id={`gtm-webapp-newagreement-${key}`}
                      doAction={() => goTo(item)}>
                      <div className="content-img-medication-sheet">
                        <img
                          src={
                            item?.product_image
                              ? item?.product_image
                              : productImg
                          }
                          alt={`nombre del producto`}
                          className="w-100"
                        />
                      </div>
                      <div className="ml-2 overflow-hidden">
                        <h2 className="title-primary mb-0 line-16 pr-2 text-ellipsis--2">
                          {item.product_name}
                        </h2>
                        <p className="txt-paragraph--small m-0 line-14 text-ellipsis--2 ">
                          {item.formula_name}
                        </p>
                        <p className="txt-paragraph--small m-0 line-14 text-ellipsis--2 ">
                          {item.presentation}
                        </p>
                        <p className="txt-paragraph--small m-0 line-14">
                          {item.laboratory_name}
                        </p>
                        <p className="txt-line--bold m-0 line-14 color-lilac">
                          {item.discount}
                        </p>
                      </div>
                    </CardProduct>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <Iframe
          url={typeFormUrl}
          width="100%"
          id="myId"
          className="content-type-form pt-3"
        />
      )}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    professionalDiscountCode: state.user.professional_discount_code,
    userInfo: state.user.userInfo,
  }
}

export default connect(mapStateToProps)(NewAgreement)
